import * as React from 'react';
import { IUser, IUserProfile } from '../../../../../common/types/user';
import { Link } from 'react-router-dom';
import './styles.scss';
import { BrandLogo, MenuToggle } from '../../atoms';
import { Helmet } from 'react-helmet';
import { useState } from 'react';

type HeaderProps = {
  brandName: string;
  appName: string;
  pageTitle: string;
  headerText?: string;
  showAuthenticated: boolean;
  userProfile?: IUserProfile;
  isMobileNavOpen?: boolean;
  setMobileNavState?: (open: boolean) => void;
  signOut?: () => void;
  homeUrl?: string;
  logo?: JSX.Element;
};

export default function Header({
  brandName,
  appName,
  pageTitle,
  headerText,
  showAuthenticated,
  userProfile,
  signOut,
  homeUrl,
  logo
}: HeaderProps) {
  const [isMobileNavOpen, setMobileNavState] = useState<boolean>(false);

  const completePageTitle = () => {
    var title = `${appName} | ${brandName}`;

    if (pageTitle) {
      title = `${pageTitle} | ${title}`;
    }

    return title;
  };

  return (
    <>
      <Helmet>
        <title>{completePageTitle()}</title>
      </Helmet>
      <header
        className={
          'cmp-header-bar container-fluid px-0 ' +
          (showAuthenticated
            ? 'cmp-header-bar--authenticated'
            : 'cmp-header-bar--unauthenticated')
        }
      >
        <div className="row">
          <div className="col-12 col-lg-4 cmp-header-bar__branding">
            {setMobileNavState && showAuthenticated && (
              <MenuToggle open={!!isMobileNavOpen} setOpen={setMobileNavState} />
            )}
            <a className="cmp-header-bar__title-link" href={homeUrl || '/'}>
              {logo ? logo : (
                <>
                  <div className="cmp-header-bar__brand-logo">
                    <BrandLogo />
                  </div>
                  <div className="cmp-header-bar__title">{appName}</div>
                </>
              )}
            </a>
          </div>
          <div className="col-12 col-lg-4 cmp-header-bar__header-text">
            {headerText}
          </div>
          <div className="col-12 col-lg-4">
            <div className={`cmp-header-bar__user ${!!isMobileNavOpen ? "nav-open" : ""}`}>
              {showAuthenticated && userProfile ? (
                <>
                  <Link
                    className="cmp-header-bar__user-image-link "
                    to="/manage"
                  >
                    <div className="cmp-header-bar__user-image-container"><div className="cmp-header-bar__user-image"></div></div>
                    {userProfile.firstName}
                  </Link>
                </>
              ) : null}
              {showAuthenticated ? (
                <>
                  <div className="cmp-header-bar__logout-container">
                    <a
                      className="cmp-header-bar__logout link--secondary"
                      onClick={signOut}
                      tabIndex={0}
                    >Logout
                </a>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
